var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c(
        "b-modal",
        _vm._b(
          {
            ref: "modal",
            attrs: { id: "modal" },
            on: { hide: _vm.hide, shown: _vm.shown },
          },
          "b-modal",
          _vm.modal.options,
          false
        ),
        [
          !_vm.modal.allowsHtml
            ? _c("span", [
                _vm._v("\n      " + _vm._s(_vm.modal.message) + "\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.modal.allowsHtml
            ? _c("span", { domProps: { innerHTML: _vm._s(_vm.modal.message) } })
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }